// extracted by mini-css-extract-plugin
export default {"container":"referForm_container__-xHXQ","heading1":"referForm_heading1__jxFfh","heading2":"referForm_heading2__BOHZH"};